import Repository from "../../services/Repository"


const reSource =  '/DiscountCodes';


export default {
    get(data ){
        return Repository.get( `${reSource}/list` + data);
    },
    create(data){
        return Repository.post( `${reSource}/create`, data);
    },
    delete(data){
        return Repository.delete( `${reSource}`+ data);
    },
    edit(data , query){
        return Repository.put( `${reSource}` + query , data);
    },
    getById(data){
        return Repository.get( `${reSource}` + data);
    }
}
